export default __webpack_public_path__ + "static/media/section7_img.278861ec.png";